import { z } from "zod";

import { CUSTOM_CODE_FORMAT_HINT } from "../constants/custom-codes";

export const CustomCodeFormSchema = z.object({
  // The pipe skips the format check on an empty code, so the field reads "Code is required".
  code: z
    .string()
    .min(1, "Code is required")
    .pipe(z.string().regex(/^[A-Za-z0-9]+(-[A-Za-z0-9]+)?$/, CUSTOM_CODE_FORMAT_HINT)),
  name: z.string().min(1, "Code name is required"),
  information: z.string().optional(),
  insuranceFee: z.number().min(0).nullable(),
  selfPayFee: z.number().min(0).nullable(),
  isActive: z.boolean(),
});

export type CustomCodeFormType = z.infer<typeof CustomCodeFormSchema>;
